export default {
  'ec.system.name': '哈尔滨新区暨自贸片区对俄综合服务平台',
  'ec.system.slogan': '',
  'ec.system.copyright': '',
}
